import { useTranslation } from 'react-i18next';

import { TripArrayFieldAddressInput } from './TripArrayFieldAddressInput';

export function PickupAddressField({ index }: { index: number }) {
  const { t } = useTranslation('common');
  return (
    <TripArrayFieldAddressInput
      index={index}
      tripField="pickupAddress"
      label={t('reservation.pickupAddress')}
      required
    />
  );
}
